module.exports = __webpack_public_path__ + "img/undraw_control_panel1_20gm.f9671c96.svg";